export const PLANNING_TABS = {
    AVALIACAO: "avaliacao",
    TESTES: "testes",
    OUTRO: "outro"
}

export const TEST_TYPES = {
    TEMPO: "tempo",
    DISTANCIA: "distancia"
}

export const INITIAL_FORM_STATE = {
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    distance: "",
    time: "",
    styles: "",
    attachment: null,
}


